// import encodeUrl from 'encodeurl'
import To from 'await-to-js'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiMixinDictionaryManagement = {
  async apiDictionary(
    arg = {
      method: '',
      params: {},
      formData: {},
      ids: [],
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'query':
        ;[err, res] = await To(wizStandardInstance.post('api/std/DicItem/query', arg.params))
        break
      case 'exactItems':
        ;[err, res] = await To(
          wizStandardInstance.get(`api/DicItem/getdicitembynameasync/${arg.params.name}`)
        )
        break
      case 'leftList':
        RecordOperation({ type: 'query' })
        const leftObj = {
          pageNo: 1,
          pageSize: 10,
          sortName: '',
          sortType: 0,
          keywords: '',
          flag: '',
        }
        if (arg.params) {
          _.assign(leftObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/DicCate/getlistpagebyconditionasync/${leftObj.pageNo}/${leftObj.pageSize}/${leftObj.sortName}/${leftObj.sortType}/${leftObj.keywords}/${leftObj.flag}`
          )
        )
        break
      case 'getRightList':
        RecordOperation({ type: 'query' })
        const obj = {
          pageNo: 1,
          pageSize: 10,
          sortName: 'seq',
          sortType: 0,
          dicCateId: ' ',
          keywords: ' ',
        }
        if (arg.params) {
          _.assign(obj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/DicItem/getdicitemlistbycateidasync/${obj.pageNo}/${obj.pageSize}/${obj.sortName}/${obj.sortType}/${obj.dicCateId}/${obj.keywords}`
          )
        )
        break
      case 'validate':
        RecordOperation({ type: 'query' })
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/DicItem/validationexsittagattrasync/${arg.params.id}`)
        )
        break
      case 'leftRow':
        RecordOperation({ type: 'detail' })
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/DicCate/getdiccatebyidasync/${arg.params.id}`)
        )
        break
      case 'deleteLeft':
        RecordOperation({ type: 'delete' })
        ;[err, res] = await To(wizStandardInstance.post('/api/DicCate/removeasync', arg.ids))
        break
      case 'addDic':
        RecordOperation({ type: 'create' })
        ;[err, res] = await To(wizStandardInstance.post('/api/DicCate/insertasync', arg.params))
        break
      case 'modifyDic':
        RecordOperation({ type: 'update' })
        ;[err, res] = await To(wizStandardInstance.post('/api/DicCate/modifyasync', arg.params))
        break
      case 'getParent':
        RecordOperation({ type: 'query' })
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/DicItem/getparentdicitemlistasync/${arg.params.dicCateId}/${arg.params.dicItemId}`
          )
        )
        break
      case 'getRightRow':
        RecordOperation({ type: 'detail' })
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/DicItem/getdicitemdetailasync/${arg.params.id}`)
        )
        break
      case 'addDetail':
        RecordOperation({ type: 'create' })
        ;[err, res] = await To(wizStandardInstance.post('/api/DicItem/adddicitemasync', arg.params))
        break
      case 'modifyDetail':
        RecordOperation({ type: 'update' })
        ;[err, res] = await To(
          wizStandardInstance.post('/api/DicItem/updatedicitemasync', arg.params)
        )
        break
      case 'deleteRight':
        RecordOperation({ type: 'delete' })
        ;[err, res] = await To(wizStandardInstance.post('/api/DicItem/deletedicitemasync', arg.ids))
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
  async apiDicExcel(
    arg = {
      method: '',
      params: {},
      formData: {},
      ids: [],
    }
  ) {
    let [err, res] = [null, null]
    const config = {
      responseType: 'arraybuffer',
      header: {
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    }
    const instance = axios.create(config)
    switch (arg.method) {
      case 'downLoad':
        RecordOperation({ type: 'export' })
        // TODO need check the url
        ;[err, res] = await To(
          instance.post(`/api/DicCate/exportexcelasync/${arg.params.keyword}`, arg.ids)
        )
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
}

export default {
  methods: ApiMixinDictionaryManagement,
}
